import * as remoteAction from "../remoteAction";

export interface ExchangeRedeemParams {
  exchangeId: string;
  amount?: number;
  originalEmail?: string;
}

// doubly nested data.transaction.transaction is a little
// clunky, but this endpoint is already in use so
// I'm hesitant to change it.
interface ExchangeRedeemSuccess {
  data: {
    transaction: Transaction;
  };
}

interface Transaction {
  transaction: {
    id: string;
    customerId: string;
    lockTableId: string;
    merchantId: string;
    createdOn: string;
  };
}

export type ExchangeRedeemActionSuccess = remoteAction.MerchantRemoteResponse<
  "EXCHANGE_REDEEM_SUCCESS",
  ExchangeRedeemSuccess
>;
export type ExchangeRedeemActionFailure = remoteAction.MerchantRemoteResponse<
  "EXCHANGE_REDEEM_FAILURE",
  any
>;
export type ExchangeRedeemActionRequest = remoteAction.MerchantRemoteResponse<
  "EXCHANGE_REDEEM_REQUEST",
  ExchangeRedeemParams
>;

export interface ExchangeRedeemAction extends remoteAction.PostRemoteRequest {
  types: {
    request: "EXCHANGE_REDEEM_REQUEST";
    success: "EXCHANGE_REDEEM_SUCCESS";
    failure: "EXCHANGE_REDEEM_FAILURE";
  };
}

export const exchangeRedeem = ({
  exchangeId,
  amount,
  originalEmail,
}: ExchangeRedeemParams): ExchangeRedeemAction => ({
  type: "MERCHANT_REMOTE_REQUEST",
  types: {
    request: "EXCHANGE_REDEEM_REQUEST",
    failure: "EXCHANGE_REDEEM_FAILURE",
    success: "EXCHANGE_REDEEM_SUCCESS",
  },
  method: "POST",
  https: true,
  data: {
    exchangeId,
    amount,
    originalEmail,
  },
  url: `/rewards/redeem/v2`,
});
